import { resourceTypes } from '~/constants';
import type { ResourceType } from '~/constants';

interface ResourceItem {
  fileId: string;
  fileName: string;
}

interface Resource {
  items: ResourceItem[];
}

// Resource utility functions
export function getResourceType(mimeType: string, extension: string): ResourceType {
  const fileExtensions = ['pdf', 'dwg', 'doc', 'xls'];
  const videoMimeTypes = ['application/octet-stream'];
  if (mimeType.indexOf('image') > -1) {
    return resourceTypes.IMAGE;
  } else if (videoMimeTypes.includes(mimeType) && !fileExtensions.includes(extension)) {
    return resourceTypes.VIDEO;
  } else {
    return resourceTypes.FILE;
  }
}

export function prepareZipLink(resource: Resource): string {
  let link = '';
  resource.items.forEach((element, index) => {
    link += `${element.fileId}%2F${element.fileName}`;
    if (index !== resource.items.length - 1) {
      link += '%2C';
    }
  });
  return link;
}

export function log(data: any): void {
  console.log(data);
}

// Legacy mixin format for backward compatibility (if needed)
const resourceMixins = {
  methods: {
    getResourceType,
    prepareZipLink,
    log
  }
};

export default resourceMixins;
